import { ComponentThemeType } from './theme.types';

export const papersTheme: ComponentThemeType = {
  MuiPaper: {
    styleOverrides: {
      elevation1: ({ theme: { palette } }) => ({
        borderRadius: 10,
        backgroundColor: palette.tertiary.main,
        color: palette.tertiary.light,
        boxShadow: 'none',
      }),
      rounded: ({ theme: { palette } }) => ({
        backgroundColor: palette.tertiary.main,
        color: palette.tertiary.light,
        borderRadius: 10,
      }),
    },
  },
};
